import React from "react";
import { useSelector } from "react-redux";

export const useIsMobile = (): boolean => {
  return useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );
};

export const useIsMobileAndTablet = (): boolean => {
  return useSelector(
    (state) =>
      state.NavigationReducer.deviceSize === "xs" ||
      state.NavigationReducer.deviceSize === "sm" ||
      state.NavigationReducer.deviceSize === "md",
  );
};

export const useUserProfile = (): { isAdmin: boolean; isBrand: boolean; isRetailer: boolean; isRep: boolean } => {
  const rUserType = useSelector(({ UserReducer }) => UserReducer.profile.accountType);
  return React.useMemo(
    () => ({
      isAdmin: rUserType === "tmtAdmin",
      isBrand: rUserType === "brand",
      isRetailer: rUserType === "retailer",
      isRep: rUserType === "rep",
    }),
    [rUserType],
  );
};

export const useDebounce = <T extends unknown>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = React.useState(value);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
